import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function StickyCallBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50" data-id="element-139">
      <a href="tel:+19252151160" className="flex items-center justify-center gap-2 w-full bg-gold text-white font-sans text-sm md:text-base uppercase tracking-widest py-4 hover:bg-gold/90 transition-colors" data-id="element-140">
        <PhoneIcon size={18} data-id="element-141" />
        <span data-id="element-142">(925) 215-1160</span>
      </a>
    </div>;
}